import mlsFrench from './mls-french';

export default option => {
    mlsFrench(option);
};
